var HttpInterceptor = function (authToken, ERR) {
    return {
        'request': function (config) {
            var token = authToken.getToken();
            if (token) {
                config.headers = angular.extend(config.headers, {
                    Authorization: 'Bearer ' + token
                });
            }
            return config;
        }
    };
};


/*
 * here we catch generic api error and show error screen
 */
var GenericApiErrorInterceptor = function (ERR, $q, $injector, errorScreenService, apiConstants, errorRouter) {

    var retry502ErrorCounters = [];
    var max502ErrorRetries = 10;

    function error502Processor(rejection) {
        if (rejection.status === 502) {

            var key = rejection.config.method + rejection.config.url;
            var counter = retry502ErrorCounters.filter(function (e) {
                return e.key === key;
            })[0];

            if (!counter) {
                counter = { key: key, retries: max502ErrorRetries};
                retry502ErrorCounters.push(counter);
            }

            if (counter.retries-- > 0) {
                var $http = $injector.get('$http');
                return $http(rejection.config);
            } else {
                counter.retries = max502ErrorRetries;
            }
        }
    }

    return {
        'responseError': function (rejection) {

            if (rejection.config.ignoreErrors) return $q.reject(rejection);

            var result = error502Processor(rejection);
            if (result) return result;

            var pattern = {
                status: rejection.status,
                method: rejection.config.method
            };

            if (rejection.config.rel) {
                var apiResource = apiConstants.METHODS.filter(function (e) {
                    return e.rel === rejection.config.rel
                })[0];

                pattern.resourceName = apiResource.methodName;
            }

            return errorRouter.route(rejection, pattern).then(function (res) {
                if (res === true) return $q.reject(rejection);
                return errorScreen();
            });

            // @return Promise<any>
            function errorScreen() {
                var $http = $injector.get('$http');
                var $state = $injector.get('$state');

                var d = $q.defer();
                var options = {};
                options.global = true;
                options.template = 'template/errorscreens/generic-error';
                options.dealerPhone = window.appSettings.dealerInfo.phone;
                options.dealerEmail = window.appSettings.dealerInfo.email;
                options.tryAgainHandler = function () {
                    errorScreenService.error(false, ERR.CONNECTION_LOST);
                    // we retry api request here
                    return $http(rejection.config).then(function (data) {
                        d.resolve(data);
                    }, function (r) {
                        d.reject(r);
                    });
                };
                options.gotoMainHandler = function () {
                    errorScreenService.error(false, ERR.CONNECTION_LOST);
                    d.reject(rejection);
                    $state.go('wellcome');
                };

                errorScreenService.error(true, ERR.CONNECTION_LOST, options);

                return d.promise;
            }

        }
    };
};

var ApiResponseTimeStatisticsInterceptor = function (apiStat) {
    return {
        'request': function (config) {
            config.startTime = new Date().getTime();
            return config;
        },
        'response': function (response) {
            apiStat.apiResponseTimeMs(new Date().getTime() - response.config.startTime);
            return response;
        }
    };
};

HttpInterceptor.$inject = ['authToken'];
GenericApiErrorInterceptor.$inject = ['errors', '$q', '$injector', 'errorScreenService', 'ApiConstants', 'errorRouterService'];
ApiResponseTimeStatisticsInterceptor.$inject = ['apiStat'];

module.exports = {
    HttpInterceptor: HttpInterceptor,
    GenericApiErrorInterceptor: GenericApiErrorInterceptor,
    ApiResponseTimeStatisticsInterceptor: ApiResponseTimeStatisticsInterceptor
};
